import Vue from 'vue';

// initial state
const state = () => ({
  results: [],
  page: 0,
});

// getters
const getters = {
  getResults: state => {
    return state.results;
  },
  getResultsIds: state => {
    return state.results.map(r => r.id);
  },
  getPage: state => {
    return state.page;
  },
};

// actions
const actions = {
  clear: ({ commit }) => {
    commit('setResults', []);
    commit('setPage', 0);
  },
};

// mutations
const mutations = {
  setResults: (state, results) => {
    state.results = results;
  },
  pushResult: (state, result) => {
    state.results.push(result);
  },
  setProfile: (state, profile) => {
    const id = profile.profileId || profile.id;
    let index = state.results.findIndex((x) => {
      return x.id === id;
    });

    Vue.set(state.results, index, profile);
  },
  setPage: (state, page) => {
    state.page = page;
  },
  incrementPage: (state) => {
    state.page = state.page + 1;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
